import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from "semantic-ui-react";

const ContactItem = ({item}) => {
  return (
    <a href={item.link} className='contact-item-link'>
      <div className='contact-item'>
        <Icon name={item.iconName} size='huge'></Icon>
        <strong>{item.name}</strong>
        <p>{item.subtitle}</p>
      </div>
    </a>
  );
};

export default ContactItem;

ContactItem.propTypes = {
  item: PropTypes.shape({
    link: PropTypes.string,
    iconName: PropTypes.string,
    name: PropTypes.string,
    subtitle: PropTypes.string
  })
}


// WEBPACK FOOTER //
// ./src/Contact/ContactItem.js